import {Injectable} from '@angular/core';
import {Observable, timer} from 'rxjs';
import { ChargeRecordPowerDto } from '../../domain/chargeRecord/chargeRecordPowerDto';
import { FrontChargeRecordHttpService } from '../http/chargeRecordHttp.service';
import { PriceDto } from '../../domain/priceDto';
import {filter, switchMap} from 'rxjs/operators';
import {IziviaAppLayoutService} from '../common/iziviaAppLayout.service';

@Injectable({
    providedIn: 'root'
})
export class ChargeRecordService {
    private pollingTimerInSecond: number = 90; // Default value : 1m30

    constructor(private readonly appLayoutService: IziviaAppLayoutService,
        private readonly chargeRecordService: FrontChargeRecordHttpService) {

    }

    loadPrice(chargeRecordId: string, pollingTimerInSecond: number): Observable<PriceDto> {
        return timer(0, (pollingTimerInSecond ? pollingTimerInSecond : this.pollingTimerInSecond) * 1000)
            .pipe(
                filter(() => this.appLayoutService.isForeground()),
                switchMap(() => this.chargeRecordService.computePrice(chargeRecordId)));
    }

    loadPower(chargeRecordId: string, pollingTimerInSecond: number): Observable<ChargeRecordPowerDto> {
        return timer(0, (pollingTimerInSecond ? pollingTimerInSecond : this.pollingTimerInSecond) * 1000)
            .pipe(
                filter(() => this.appLayoutService.isForeground()),
                switchMap(() => this.chargeRecordService.computePower(chargeRecordId)));
    }
}
